module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "sign"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tActive),
      expression: "tActive"
    }],
    staticClass: "radius_1 radius"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tActive),
      expression: "tActive"
    }],
    staticClass: "radius_2 radius"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tActive),
      expression: "!tActive"
    }],
    staticClass: "radius_3 radius"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tActive),
      expression: "!tActive"
    }],
    staticClass: "radius_4 radius"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tActive),
      expression: "tActive"
    }],
    staticClass: "radius_5 radius"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tActive),
      expression: "!tActive"
    }],
    staticClass: "radius_6 radius"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      class: ['identity', {
        iActive: index == _vm.n
      }],
      on: {
        "click": function($event) {
          return _vm.toggle(index)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.identity))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sign-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.n == 0),
      expression: "n == 0"
    }],
    staticClass: "s-form",
    attrs: {
      "id": "signIn"
    }
  }, [_c('form', {
    attrs: {
      "id": "signInForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.signIn.apply(null, arguments)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("高校邦账号")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.userName),
      expression: "user.userName"
    }],
    attrs: {
      "name": "username",
      "type": "text",
      "placeholder": "请输入账号"
    },
    domProps: {
      "value": (_vm.user.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "userName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warnPhone),
      expression: "warnPhone"
    }],
    ref: "warnPhone",
    staticClass: "warning"
  }, [_vm._v("请输入手机号码!")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("密码")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warnPassword),
      expression: "warnPassword"
    }],
    ref: "warnPassword",
    staticClass: "warning"
  }, [_vm._v("请输入密码!")])]), _vm._v(" "), _c('router-link', {
    staticClass: "forgetpwd",
    attrs: {
      "to": "/resetPassword"
    }
  }, [_vm._v("\n              忘记密码？\n            ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "rtSignUp",
    attrs: {
      "to": "/signUp"
    }
  }, [_vm._v("\n             注册\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn wanxiang",
    on: {
      "click": _vm.goThirdLogin
    }
  }, [_vm._v("万象登录")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.n == 1),
      expression: "n == 1"
    }],
    staticClass: "s-form joinRoom"
  }, [_c('form', {
    attrs: {
      "id": "joinRoomForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.joinRoom.apply(null, arguments)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("教室ID（询问老师6位教室ID）")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.roomId),
      expression: "roomId"
    }],
    ref: "roomId",
    attrs: {
      "name": "roomid",
      "type": "text",
      "placeholder": "请输入教室ID"
    },
    domProps: {
      "value": (_vm.roomId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.roomId = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_vm._v(_vm._s(_vm.errorTip.room))])]), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "#DADBDC"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    ref: "name",
    attrs: {
      "name": "name",
      "type": "text",
      "placeholder": "请输入真实姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "warning"
  }, [_vm._v(_vm._s(_vm.errorTip.name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("加入教室")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "signUp"
  }, [_c('input', {
    staticClass: "btn-primary btn",
    attrs: {
      "type": "submit",
      "value": "登录"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b029817","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/home.vue
// module id = 513
// module chunks = 1